import { configureStore } from "@reduxjs/toolkit";

import cartReducter from "./cartSlice";
import productReducer from "./productSlice";

import userAuthReducer, { logout, setAuthSession } from "./userAuthSlice";
import userSettingsReducer from "./userSettingsSlice";
import currencyReducer from "./currencySlice";
import disputeReducer from "./disputeSlice";
import wishlistReducer from "./wishlistSlice";
import followedStoresReducer from "./followedStoresSlice";
import orderReducer from './orderSlice';
import { setSessionTokenUpdateHandler, setUnauthorizedHandler } from "../util/API";
import returnRefundReducer from "./returnRefundSlice";
import shippingAddresse from "./shippingAddressSlice";
import checkoutReducer from "./checkoutSlice";
import uiReducer from "./uiSlice";
import productQnaReducer from "./productQnaSlice";


const store = configureStore({
  reducer: {
    ui: uiReducer,
    cart: cartReducter,

    userAuth: userAuthReducer,
    products: productReducer,
    userSettings: userSettingsReducer,
    currency: currencyReducer,
    dispute: disputeReducer,
    wishlist: wishlistReducer,
    followedStores: followedStoresReducer,
    order: orderReducer,
    returns: returnRefundReducer,
    shippingAddresses: shippingAddresse,
    checkout: checkoutReducer,
    productQna: productQnaReducer,
    paymentMethods: require("./paymentMethodSlice").default
  },
});

setUnauthorizedHandler(() => {
  store.dispatch(logout());
});

setSessionTokenUpdateHandler((session) => {
  store.dispatch(setAuthSession(session));
});

export default store;
